// tslint:disable-next-line
// `_kasparov.api_idretter_${sport}_turneringer_${tournament}_sesonger_${season}_konkurranser_${group}_kamper_${match}`

export const generatePusherBaseUrl = (
  sport: string,
  tournament: string,
  season: string
): string => {
  return `_kasparov.api_idretter_${sport}_turneringer_${tournament}_sesonger_${season}_konkurranser`
}

export const generatePusherUrl = (
  match: string | number,
  group: string | number,
  baseUrl: string
) => {
  if (!match || !group) return null

  // tslint:disable max-line-length
  return `${baseUrl}_${group}_kamper_${match}`
}
